<%= form_with(model: showcase, class: "contents") do |form| %>
  <% if showcase.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(showcase.errors.count, "error") %> prohibited this showcase from being saved:</h2>

      <ul class="list-disc ml-6">
        <% showcase.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :name %>
    <%= form.text_field :name, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:name].none?, "border-red-400 focus:outline-red-600": showcase.errors[:name].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :key %>
    <%= form.text_field :key, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:key].none?, "border-red-400 focus:outline-red-600": showcase.errors[:key].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :year %>
    <%= form.number_field :year, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:year].none?, "border-red-400 focus:outline-red-600": showcase.errors[:year].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :date %>
    <%= form.text_field :date, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:date].none?, "border-red-400 focus:outline-red-600": showcase.errors[:date].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:order].none?, "border-red-400 focus:outline-red-600": showcase.errors[:order].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :location_id %>
    <%= form.text_field :location_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": showcase.errors[:location_id].none?, "border-red-400 focus:outline-red-600": showcase.errors[:location_id].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
